import PersistantVideoBarComponent from './persistent-video-bar.component';
import * as PersistantBarActions from './persistent-video-bar.actions';
import { connect } from 'react-redux';

const mapStateToProps = (state, ownProps) => {
	//console.log("[PersistentVideoBar] mapStateToProps - state:\n",state,"\n[PersistentVideoBar] mapStateToProps -  ownProps:\n",ownProps);
    const {show, height } = state.PersistentVideoBar;
    const { "series-path": seriesPath,  configs } = state.Main;
    const { pathname } =  ownProps.location;
    const path = pathname.replace(seriesPath,"");
    const index = configs.findIndex( item => {
        return item.path === path;
    });

    const nextConfig = configs[index+1];
    const showUpNext = (nextConfig != null && nextConfig.comingsoon === false);
    const nextTitle = nextConfig == null ? "" : nextConfig.title;
    const nextIsIfi = nextConfig == null ? false : nextConfig.isIfi;
    const nextEpisodeTag = nextConfig == null ? "" : nextConfig.episodeTag;
    const nextPath = nextConfig == null ? "" : nextConfig.path;
    const nextComingsoon = nextConfig == null ? "" : nextConfig.comingsoon;
    const upNext = {
        "show": showUpNext,
        "title": nextTitle,
        "isIfi": nextIsIfi,
        "episodeTag": nextEpisodeTag,
        "path": `${seriesPath}${nextPath}`,
        "comingsoon": nextComingsoon

    }
    const props = Object.assign({}, ownProps, {
        height,
    	show,
        "up-next": upNext
    });

    //console.log("[PersistentVideoBar] mapStateToProps - props:\n",props);
    return props;
};

const mapDispatchToProps = dispatch => {
    return {
        onReady: (containerEl,upNext) => {
            dispatch(PersistantBarActions.ready(containerEl,upNext))
        },
        onDestroy: () => {
            dispatch(PersistantBarActions.destroy())
        },
        onAnimate: (height) => {
            dispatch(PersistantBarActions.animate(height));
        },
        onUpdate: (upNext) => {
            dispatch(PersistantBarActions.update(upNext))
        }
    }
};

const PersistantVideoBar = connect(mapStateToProps,mapDispatchToProps)(PersistantVideoBarComponent);
export default PersistantVideoBar;